import { Switch } from '@mui/material'

type StatusIndicatorProps = {
  name: string
  label: string
  isActive: boolean
  onClick?: () => void
}

export default function ({
  isActive,
  name,
  label,
  ...props
}: StatusIndicatorProps) {
  function handleClick(e: React.MouseEvent) {
    e.stopPropagation() // Capture click event so parent is unaffected.
    if (props.onClick) props.onClick()
  }

  return (
    <Switch
      {...props}
      role="switch"
      name={name + 'Toggle'}
      checked={isActive}
      onClick={handleClick}
      title={`Toggle ${label} `}
    />
  )
}
